<template>
  <color-picker
    :selected="selected"
    :history-colors="colorsSelected"
    :current-color="currentColor"
    v-bind="$attrs"
    @save="onSave"
    @select="selectColor"
  />
</template>

<script>
import ColorPicker from './ColorPicker';

export default {
  name: 'ColorPickerContainer',
  components: {
    ColorPicker,
  },
  inheritAttrs: false,
  props: {
    currentColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    selected: {
      set(color) {
        // this.$store.commit('preferences/setColor', color);
      },
      get() {
        return this.$store.state.preferences.color;
      },
    },
    colorsSelected: {
      set(color) {
        /** Note: We are dispatching the commit when se save the color because
         * the wheel has 2 events- Save and Input
         * and we don't want to save each input event.
        */
        // this.$store.commit('preferences/pickColor', color);
      },
      get() {
        return this.$store.state.preferences.colorsSelected.filter((x) => x !== undefined && x.length > 0);
      },
    },
  },
  methods: {
    onSave(color) {
      this.$emit('save', color);
      this.$store.commit('preferences/pickColor', color);
    },
    selectColor(color) {
      this.$emit('input', color);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
